module.exports = __webpack_public_path__ + "img/messenger.5cee322.svg";